import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";

const DEFAULT_PASSING_GRADE = 70;

export const QuizSettings = () => {
  const { watch, setValue } = useFormContext();
  const { set_a_passing_grade } = watch();
  const passingGrade = watch("quiz[passing_grade]");

  useEffect(() => {
    if (!set_a_passing_grade) {
      setValue("quiz[passing_grade]", null);
      setValue("quiz[enforce_passing_grade]", false);
    } else if (passingGrade === null) {
      setValue("quiz[passing_grade]", DEFAULT_PASSING_GRADE);
    }
  }, [set_a_passing_grade, passingGrade, setValue]);

  return (
    <>
      <Form.Item
        id="comments_enabled"
        name="comments_enabled"
        hideBorder
        hideDescription
        className="!pt-0"
      >
        <Form.Checkbox
          label={t("courses.edit.lesson.enable_comments")}
          name="comments_enabled"
          className="!mt-2"
        />
      </Form.Item>
      <Form.Item
        id="set_a_passing_grade"
        name="set_a_passing_grade"
        hideBorder
        hideDescription
        className="!pt-0"
      >
        <Form.Checkbox
          name="set_a_passing_grade"
          label={t("courses.edit.lesson.set_a_passing_grade")}
          className="!mt-2"
        />
      </Form.Item>
      {set_a_passing_grade && (
        <>
          <Form.Item
            id="quiz_passing_grade"
            name="quiz[passing_grade]"
            hideBorder
            hideDescription
            className="!pt-0"
          >
            <Form.Input type="number" min="0" max="100" step="1" suffix="%" />
          </Form.Item>
          <Form.Item
            id="enforce_passing_grade"
            name="quiz[enforce_passing_grade]"
            hideBorder
            hideDescription
            className="!pt-0"
          >
            <Form.Checkbox
              name="quiz[enforce_passing_grade]"
              label={t("courses.edit.lesson.enforce_passing_grade")}
              description={t(
                "courses.edit.lesson.enforce_passing_grade_description",
              )}
              className="!mt-2"
              isDescriptionTooltip
            />
          </Form.Item>
        </>
      )}
      <Form.Item
        id="quiz_hide_answers"
        name="quiz[hide_answers]"
        hideBorder
        hideDescription
        className="!pt-0"
      >
        <Form.Checkbox
          name="quiz[hide_answers]"
          label={t("courses.edit.lesson.hide_answers")}
          className="!mt-2"
        />
      </Form.Item>
    </>
  );
};
